import { useTranslation } from '../i18n';
import React from 'react';
import { Tag } from 'antd';

/**
 * 发票状态标签（统一数据源）
 *
 * 覆盖后端全部发票状态，颜色/文案在 admin 与 user 两端保持一致，
 * 避免各页面各写一份 statusMap 造成状态缺失或文案分叉。
 */
export const INVOICE_STATUS_MAP = {
    draft: { color: 'default', text: '草稿' },
    unpaid: { color: 'warning', text: '未支付' },
    partial: { color: 'processing', text: '部分支付' },
    paid: { color: 'success', text: '已支付' },
    cancelled: { color: 'error', text: '已取消' },
    refunded: { color: 'default', text: '已退款' },
    void: { color: 'error', text: '已作废' },
};

const InvoiceStatusTag = ({ status }) => {
    const { t } = useTranslation();
    const config = INVOICE_STATUS_MAP[status] || { color: 'default', text: status };
    return <Tag color={config.color}>{t(config.text)}</Tag>;
};

export default InvoiceStatusTag;
